import { createSelector } from 'reselect'
import { RootStoreState } from 'modules/root'
import { TRIAL_DURATION_MILLIS } from './contants'

export const currentUser = (state: RootStoreState) => state.user.user
export const currentEditingUser = (state: RootStoreState) => state.user.editingUser

export const currentUserFormState = createSelector(
	currentUser,
	currentEditingUser,
	(user, editingUser) => {
		if (editingUser) {
			return editingUser
		}

		return user
	},
)

export const currentUserFullName = createSelector(
	currentUser,
	(user) => {
		if (user.givenName && user.familyName) {
			return `${user.givenName} ${user.familyName}`
		} else if (user.givenName) {
			return user.givenName
		} else if (user.familyName) {
			return user.familyName
		} else {
			return 'Anonymous'
		}
	},
)

export const subscriber = (state: RootStoreState) => state.user.userAdministrative ? !!state.user.userAdministrative.whenSubscribedTo : undefined

/* These are memoised so the Date identity is stable, otherwise every call returns a new Date and
   components comparing these props re-render on every store change.
 */
export const subscriptionRenewalDate = createSelector(
	(state: RootStoreState) => state.user.userAdministrative ? state.user.userAdministrative.whenSubscribedTo || null : undefined,
	(whenSubscribedTo) => whenSubscribedTo === undefined ? undefined : whenSubscribedTo ? new Date(whenSubscribedTo) : new Date(),
)

export const trialExpiryDate = createSelector(
	(state: RootStoreState) => state.user.user.whenCreated,
	(whenCreated) => whenCreated ? new Date(Date.parse(whenCreated) + TRIAL_DURATION_MILLIS) : new Date(),
)
